module.exports = __webpack_public_path__ + "img/toastr-img-error.fc52ab8f.svg";